import { loadScript, loadStylesheet } from './assetLoader';

export const injectHorizontalPlayerAssets = async (organisation: string, bidConfig: Record<string, any> = undefined) => {
  const scriptTop = loadScript(window.document);
  const stylesheetTop = loadStylesheet(window.document);
  const assets = [
    scriptTop(`https://imasdk.googleapis.com/js/sdkloader/ima3.js`),
    scriptTop(`${__PIXELS_JS_ENDPOINT__}/${organisation}/dual-${organisation}.main.js`),
    stylesheetTop(`${__PIXELS_JS_ENDPOINT__}/${organisation}/dual-${organisation}.main.css`)
  ];

  if (bidConfig !== undefined) {
    assets.unshift(scriptTop(`${__PUB_ENDPOINT__}/prebid.${organisation}.min.js`));
  }

  await Promise.all(assets);
};
